/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState } from "react";

/** Utilities */
import { setFieldSetting } from "../../../../../../utils/formFieldUtils/ManageFields";
import { FieldSettingType } from "../../../../../../components/finalForms/libs/data/fieldSettingType";

/** Common Components */
import FormCreator from "../../../../../../components/finalForms/FormCreator";

/** Configuration files */
import { addressFieldConfig } from "../../../../../departments/features/addresses/components/AddAddress.formfield.config";
import { ContractContext } from "../../../../../../utils/context/ContractContext";
import { useLazyGetAllStateListQuery } from "../../../../../../app/services/commonAPI";
import { setDropdownOptions } from "../../../../../../components/finalForms/libs/data/mapDropdownOptions";

const Address = (props,ref) => {
  const AddressRef = useRef();
  const { contractData } = useContext(ContractContext);

  const [addressData, setAddressData] = useState(addressFieldConfig);

  const [getallStateList, {
    isFetching: isStateFetching,
    isSuccess: isStateFetched,
    data: stateData }] = useLazyGetAllStateListQuery();

  const handleShippingSameAsBilling = (dataField, updatedData) => {

    setAddressData((prev) => {
      const updatedConfig = { ...prev };
      const billingSection = updatedConfig.section.find(sec => sec.sectionId === "billingAddressSection");

      // Billing Address Checkbox
      if (dataField === "billTypeAddress" && billingSection?.sectionId === "billingAddressSection") {
        const disable = !updatedData?.billTypeAddress;
        const billingFields = [
          "sContractBillName2",
          "sContractAddr1",
          "sContractAddr2",
          "sContractZip",
          "sContractCity",
          "sContractState",
          "sContractPhoneNumber",
        ];
        billingFields.forEach(id =>
          setFieldSetting(updatedConfig, id, FieldSettingType.DISABLED, disable)
        );
      }

      // Billing Email Checkbox
      if (dataField === "billTypeEmail" && billingSection?.sectionId === "billingAddressSection") {
        const disable = !updatedData?.billTypeEmail;
        const emailFields = ["sBillEmailName", "sBillEmail"];
        emailFields.forEach(id =>
          setFieldSetting(updatedConfig, id, FieldSettingType.DISABLED, disable)
        );
      }

      // Shipping same as billing
      if (dataField === "bShippingSameAsBilling") {
        const isChecked = updatedData.bShippingSameAsBilling;

        updatedConfig.initialState.bShippingSameAsBilling = isChecked;

        const shippingFields = [
          "sContractShippingName1",
          "sContractShippingName2",
          "sContractShippingAddr1",
          "sContractShippingAddr2",
          "sContractShippingZip",
          "sContractShippingCity",
          "sContractShippingState",
          "sContractShippingPhoneNumber",
          "sContractShippingFaxNumber",
        ];

        shippingFields.forEach(id =>
          setFieldSetting(updatedConfig, id, FieldSettingType.DISABLED, isChecked)
        );

        if (isChecked) {
          updatedConfig.initialState = {
            ...updatedConfig.initialState,
            sContractShippingName1: updatedConfig.initialState.sContractName1,
            sContractShippingName2: updatedConfig.initialState.sContractBillName2,
            sContractShippingAddr1: updatedConfig.initialState.sContractAddr1,
            sContractShippingAddr2: updatedConfig.initialState.sContractAddr2,
            sContractShippingZip: updatedConfig.initialState.sContractZip,
            sContractShippingCity: updatedConfig.initialState.sContractCity,
            sContractShippingState: updatedConfig.initialState.sContractState,
            sContractShippingFaxNumber: updatedConfig.initialState.sContractFaxNumber,
            sContractShippingPhoneNumber: updatedConfig.initialState.sContractPhoneNumber,
          };
        } else {
          shippingFields.forEach(id => {
            updatedConfig.initialState[id] = "";
          });
        }
      }
      return updatedConfig;
    });
  };

  useEffect(() => {
  if (!contractData) return;

  getallStateList();
  setFieldSetting(addressData, 'sContractState', FieldSettingType.ISFIELDDATALOADING, true);
  const formData = { ...addressData };
  const isSameAsBilling = contractData?.bShippingSameAsBilling ?? false;

  const billTypeAddress = contractData?.lBillType === 1 || contractData?.lBillType === 3;
  const billTypeEmail = contractData?.lBillType === 2 || contractData?.lBillType === 3;

  const billingFields = {
    sContractName1: contractData?.sContractName1,
    sContractName2: contractData?.sContractName2,
    sContractAddr1: contractData?.sContractAddr1,
    sContractAddr2: contractData?.sContractAddr2,
    sContractState: contractData?.sContractState,
    sContractZip: contractData?.sContractZip,
    sContractCity: contractData?.sContractCity,
    sContractBillName2: contractData?.sContractBillName2,
    sBillEmail: contractData?.sBillEmail,
    sContractPhoneNumber: contractData?.sContractPhoneNumber,
    sContractFaxNumber: contractData?.sContractFaxNumber,
    dblAmtInvoiced: contractData?.dblAmtInvoiced,
    sBillEmailName: contractData?.sBillEmailName,
    billTypeAddress: billTypeAddress,
    billTypeEmail: billTypeEmail,
    bShowShippingAddressOnInvoice: contractData?.bShowShippingAddressOnInvoice,
  };

  const shippingFields = isSameAsBilling
    ? {
        sContractShippingName1: billingFields.sContractName1,
        sContractShippingName2: billingFields.sContractName2,
        sContractShippingAddr1: billingFields.sContractAddr1,
        sContractShippingAddr2: billingFields.sContractAddr2,
        sContractShippingState: billingFields.sContractState,
        sContractShippingZip: billingFields.sContractZip,
        sContractShippingCity: billingFields.sContractCity,
        sContractShippingFaxNumber: billingFields.sContractFaxNumber,
        sContractShippingPhoneNumber: billingFields.sContractPhoneNumber,
      }
    : {
        sContractShippingName1: "",
        sContractShippingName2: "",
        sContractShippingAddr1: "",
        sContractShippingAddr2: "",
        sContractShippingState: "",
        sContractShippingZip: "",
        sContractShippingCity: "",
        sContractShippingFaxNumber: "",
        sContractShippingPhoneNumber: "",
      };

  formData.initialState = {
    ...billingFields,
    bShippingSameAsBilling: isSameAsBilling,
    ...shippingFields,
  };

  setAddressData(formData);

  handleShippingSameAsBilling("bShippingSameAsBilling", formData.initialState);

}, [contractData]);

useEffect(() => {
  if (!isStateFetching && isStateFetched && stateData) {
      setDropdownOptions(stateData, 'stateCode', 'stateCode', addressData, 'sContractState', setAddressData);
      setDropdownOptions(stateData, 'stateCode', 'stateCode', addressData, 'sContractShippingState', setAddressData);
      setFieldSetting(addressData, 'sContractState', FieldSettingType.ISFIELDDATALOADING, false);
  }
}, [isStateFetching, isStateFetched, stateData]);

useImperativeHandle(ref, () => ({
  getFormData: () => {
    if (ref?.current) {
      const ContractAddressFormData = AddressRef.current.getFormDataWithoutValidation();
      if (ContractAddressFormData) {
        return { ...ContractAddressFormData };
      }
    }
    return null;
  },
}));

  return (
    <div className="row">
      <FormCreator
        ref={AddressRef}
        config={addressData}
        onColumnChange={handleShippingSameAsBilling}
      />
    </div>
  );
};
export default forwardRef(Address);